import { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";

function OtherSetting() {
  const [notification, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const [courses, setCourses] = useState([]);
  const [selectedAarti, setSelectedAarti] = useState(null);
  const [aartiData, setAartiData] = useState([]);
  const [aartiLoading, aartiSetLoading] = useState(true);

  const [aartiFormData, setAartiFormData] = useState({
    aarti_name: "",
    description: "",
    thumbnail_url: "",
    registeration_link: "",
  });

  const [formData, setFormData] = useState({
    course_name: "",
    thumbnail_url: "",
    register_link: "",
    description: "",
  });

  const removeFormData = () => {
    setFormData({
      course_name: "",
      thumbnail_url: "",
      register_link: "",
      description: "",
    });
  };

  const axiosAPI = useAxios();

  // Get All Notifications
  const getNotifications = async () => {
    try {
      const response = await axiosAPI.get(
        "/api/notification/get-notifications",
      );
      setNotifications(response.data.results);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Get All Courses
  const getCourses = async () => {
    try {
      const response = await axiosAPI.get("/api/other/setting/get-courses");
      const coursesData = response.data.results || [];
      setCourses(coursesData);
      if (coursesData.length > 0) {
        setFormData(coursesData[0]);
        setCurrentUserId(coursesData[0].id);
      }
      //   setCourses(response.data.results);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Fetch Aarti data
  const getAarti = async () => {
    try {
      const response = await axiosAPI.get("/api/other/setting/get-aarti");
      const data = response.data.results || [];
      setAartiData(data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // getNotifications();
    getCourses();
    getAarti();
  }, []);

  // console.log("form data", formData);
  // console.log("Course data", courses);

  // Handle Input Changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      thumbnail_url: formData.thumbnail_url,
      register_link: formData.register_link,
    };

    // console.log(payload);

    // return

    try {
      setLoading(true);
      let response = await axiosAPI.put(
        `/api/other/setting/update-course/${currentUserId}`,
        payload,
      );
      window.notifyMessage("Success", "Course updated successfully", "success");
      setLoading(false);
      hideModal("newUserModal");
      getNotifications();
      getCourses();
      removeFormData();
      setIsEditMode(false);
      // window.location.reload(); // Reload page to reflect changes in the notification list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);

    // Find the notification with this ID and populate the form
    const selectedNotification = notification.find((notif) => notif.id === id);
    if (selectedNotification) {
      setFormData({
        title: selectedNotification.notification_title,
        message: selectedNotification.notification_message,
      });
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("newUserModal"),
    );
    modal.show();
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/notification/delete-notification/${id}`,
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      getNotifications();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  // Helper functions to manage modal visibility
  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  const openAddModal = () => {
    showModal("newUserModal");
  };

  // console.log("Courses", courses);

  return (
    <div className="container">
      <div className="page-inner">
        <h4 className="mt-0">Course Settings</h4>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card mb-4">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="card-body mb-3">
                  <div className="row">
                    {/* Profile Pic */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Thumbnai Url</h6>
                      <div className="imgs-account-bs">
                        {loading ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData?.thumbnail_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="profile_pic"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="course_name" className="form-label">
                        Course Name
                      </label>
                      <input
                        type="text"
                        id="course_name"
                        className="form-control"
                        value={formData.course_name}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="description" className="form-label">
                        Course Description
                      </label>
                      <input
                        type="text"
                        id="description"
                        className="form-control"
                        value={formData.description}
                        onChange={handleChange}
                        disabled
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="thumbnail_url" className="form-label">
                        Thumbnail Url
                      </label>
                      <input
                        type="text"
                        id="thumbnail_url"
                        className="form-control"
                        value={formData.thumbnail_url}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="register_link" className="form-label">
                        Register Link
                      </label>
                      <input
                        type="text"
                        id="register_link"
                        className="form-control"
                        value={formData.register_link}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-dark btn-round me-2"
                      disabled={handleSubmit}
                    >
                      {/* {isSubmitting ? "Saving..." : "Save changes"} */}
                      Save Changes
                    </button>
                    <button
                      type="reset"
                      className="btn btn-outline-secondary btn-round"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="page-inner">
        <h4 className="mt-0">Aarti Settings</h4>
        <div className="card mb-4">
          <div className="card-body mb-3">
            <div className="row mt-3">
              <div className="col-md-12">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="row">
                    <div className="">
                      {/* <select
                      //   onChange={(e) => handleAartiSelection(e)}
                      //   value={selectedAarti}
                      >
                        {aarti.map((aarti) => (
                          <option key={aarti.id} value={aarti.id}>
                            {aarti.aarti_name}
                          </option>
                        ))}
                      </select> */}
                    </div>

                    {/* Profile Pic */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Thumbnai Url</h6>
                      <div className="imgs-account-bs">
                        {loading ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData?.thumbnail_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="profile_pic"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="course_name" className="form-label">
                        Aarti Name
                      </label>
                      <input
                        type="text"
                        id="course_name"
                        className="form-control"
                        value={formData.course_name}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="description" className="form-label">
                        Aarti Description
                      </label>
                      <input
                        type="text"
                        id="description"
                        className="form-control"
                        value={formData.description}
                        onChange={handleChange}
                        disabled
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="thumbnail_url" className="form-label">
                        Thumbnail Url
                      </label>
                      <input
                        type="text"
                        id="thumbnail_url"
                        className="form-control"
                        value={formData.thumbnail_url}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="register_link" className="form-label">
                        Registeration Link
                      </label>
                      <input
                        type="text"
                        id="register_link"
                        className="form-control"
                        value={formData.register_link}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-dark btn-round me-2"
                      disabled={handleSubmit}
                    >
                      {/* {isSubmitting ? "Saving..." : "Save changes"} */}
                      Save Changes
                    </button>
                    <button
                      type="reset"
                      className="btn btn-outline-secondary btn-round"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherSetting;
